/**
 * @property LOG
 * @type {Object}
 * @final
 */
export const LOG = {
    DEBUG: 0,
    INFO: 1,
    WARNING: 2,
    ERROR: 3,
    FATAL: 4
};
